import AppForm from '../app-components/Form/AppForm';

Vue.component('logs-transaction-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                ref_id:  '' ,
                table_name:  '' ,
                desc:  '' ,
                old_value:  '' ,
                new_value:  '' ,
                
            }
        }
    }

});